import React from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { Link } from "@quintype/components";
import {
  getRecipeCookTime,
  getStoryHeadline,
  getStoryLabel,
  isExternalStory,
  storyTemplates,
} from "../../../utils/story";
import { useDeviceType } from "../../../custom-hooks/useDeviceType";
import { HeroImage } from "../../../atoms/HeroImage";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import CookTime from "../../../atoms/CookTime";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";
import SubHeadline from "../../../atoms/SubHeadline";

import "./main-story.m.css";

const MainStory = ({
  story,
  showCookTime,
  enableServingsForFirstStory,
  showTimeStamp,
  showReadTime,
  enableAuthorNameOfFirstStory,
  showSubheadlineForFirstStory,
  sectionSlug,
}) => {
  const label = getStoryLabel(story);
  const headline = getStoryHeadline(story);
  const subHeadLine = get(story, ["subheadline"], "");
  const authorName = get(story, ["author-name"], "");
  const servings = get(story, ["metadata", "servings"], "");

  const isRecipe = story && story["story-template"] === storyTemplates.recipe;
  const cookTime = getRecipeCookTime(story);

  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl ? externalStoryUrl : `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";

  const shouldShowCookTime = cookTime && showCookTime && isRecipe;
  const shouldShowServings = enableServingsForFirstStory && servings;
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";
  const isTablet = deviceType === "tablet";

  let iconSizes = { width: 64, height: 64 };
  isTablet && (iconSizes = { width: 48, height: 48 });
  isMobile && (iconSizes = { width: 32, height: 32 });
  return (
    <Link href={href} target={target} styleName="main-story">
      <HeroImage story={story} aspectRatio={[[16, 9]]} iconSizes={iconSizes} isImageResponsive={false} />
      <div styleName="text-container">
        {label && <Label story={story} />}
        {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
        {showSubheadlineForFirstStory && subHeadLine && (
          <SubHeadline styleName="subHeadLine" subHeadline={subHeadLine} sectionSlug={sectionSlug} />
        )}
        {enableAuthorNameOfFirstStory && authorName && <p styleName="authorName">{authorName}</p>}

        {!isRecipe && <PublishAndReadTime story={story} showReadTime={showReadTime} showTimestamp={showTimeStamp} />}
        {(shouldShowServings || shouldShowCookTime) && (
          <div styleName="attributes">
            {shouldShowCookTime && <CookTime cookTime={cookTime} />}
            {shouldShowServings && shouldShowCookTime && <span styleName="separator">|</span>}
            {shouldShowServings && <p styleName="servings">Servings: {servings}</p>}
          </div>
        )}
      </div>
    </Link>
  );
};

MainStory.prototype = {
  story: PropTypes.shape({
    slug: PropTypes.string,
  }),
  showCookTime: PropTypes.bool,
  enableServingsForFirstStory: PropTypes.bool,
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  enableAuthorNameOfFirstStory: PropTypes.bool,
  showSubheadlineForFirstStory: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default MainStory;
